import { Link } from 'react-router-dom';

/**
 * Footer - Application footer with links and copyright
 */
function Footer() {
  const currentYear = new Date().getFullYear();
  // TODO: Get version from package.json or environment variable
  const version = process.env.npm_package_version || '2.0.0';

  return (
    <div className="footer sub-container">
      <p>
        <a className="hlink" href="https://www.seansoftinc.com/Home/About" target="_blank" rel="noopener noreferrer">
          About Us
        </a>
        <span className="pipe"> | </span>
        <Link className="hlink" to="/contact">
          Contact Us
        </Link>
        <span className="pipe"> | </span>
        <Link className="hlink" to="/faq">
          FAQ
        </Link>
      </p>
      <span>&copy;</span>
      <span className="copyright-year">{currentYear}</span>
      <span> Seansoft Corporation - All Rights Reserved. - Version {version}</span>
    </div>
  );
}

export default Footer;
